export const version = '@TMX_VERSION@';
